<template>
  <div class="list">
    <!-- header-title -->
    <div class="header-title flex-row flex__between margin-bottom-10">
      <div class="leftSection flex-row flex__left">
        <div class="theTitle theTitle__lv5">
          <!--<el-checkbox class="select-doc margin-left-10"/>-->
          <span class="stt">STT</span>
        </div>
        <div
          class="theTitle theTitle__lv1 flex-row flex__left"
          @click="doSort('taskTitle')"
        >
          Công việc
          <sort-caret :order="order" :sort="sort" :field="'taskTitle'"/>
        </div>
      </div>
      <div class="rightSection flex-row flex__right">
        <div
          class="theTitle theTitle__lv2 flex-row flex__left"
          @click="doSort('assignerName')"
        >
          Người giao
          <sort-caret :order="order" :sort="sort" :field="'assignerName'"/>
        </div>
        <div
          class="theTitle theTitle__lv2 flex-row flex__left"
          @click="doSort('receiverName')"
        >
          Chủ trì
          <sort-caret :order="order" :sort="sort" :field="'receiverName'"/>
        </div>
        <div
          class="theTitle theTitle__lv3 flex-row flex__left"
          @click="doSort('deadline')"
        >
          Hạn hoàn thành
          <sort-caret :order="order" :sort="sort" :field="'deadline'"/>
        </div>

        <div
          class="theTitle theTitle__lv3 flex-row flex__left"
          @click="doSort('completionTime')"
        >
          <span class="txt">Thời gian hoàn thành</span>
          <sort-caret :order="order" :sort="sort" :field="'completionTime'"/>
        </div>
        <div
          class="theTitle theTitle__lv3 flex-row flex__left"
          @click="doSort('updateTime')"
        >
          Thời gian duyệt
          <sort-caret :order="order" :sort="sort" :field="'updateTime'"/>
        </div>
        <div
          class="theTitle theTitle__lv3 flex-row flex__left"
          @click="doSort('evaluationPoint')"
        >
          Đánh giá
          <sort-caret :order="order" :sort="sort" :field="'evaluationPoint'"/>
        </div>
      </div>
    </div>
    <!-- list-docs -->
    <VuePerfectScrollbar
      class="scroll-area"
      :settings="settings"
      infinite-wrapper
    >
      <div class="list-docs">
        <div
          v-for="(item, itemIndex) in tasks"
          :key="item.id"
          class="item flex-row flex__between"
          @click="watchDetail(item)"
        >
          <div class="leftSection flex-row flex__left">
            <div class="theTitle__lv5">
              <div class="flex-row flex__left">
                <div class="section-check">
                  <!--<el-checkbox v-model="checkAll" class="select-doc margin-left-10"/>-->
                  <span class="stt">{{ itemIndex + 1 }}</span>
                </div>
                <task-status-icon :taskStatus="item.taskStatus"/>
              </div>
            </div>
            <div class="theTitle__lv1">
              <div class="title-docs flex-col flex__left">
                <div class="tt_1 clickable">{{ item.taskTitle }}</div>
                <div class="tt_2 jobInfoMore">
                  <div
                    class="relatedLink"
                    v-if="
                      item.parentTaskTitle ||
                        item.vbIncomingDocQuote ||
                        item.vbOutgoingDocQuote
                    "
                  >
                    <div class="" v-if="item.parentTaskTitle">
                      <i class="fas fa-check-circle color__silver"></i>
                      <span v-if="item.parentTaskTitle">
                        &nbsp;{{ item.parentTaskTitle }}
                      </span>
                    </div>
                    <div
                      class=""
                      v-if="item.vbIncomingDocQuote || item.vbOutgoingDocQuote"
                    >
                      <i class="fas fa-file-export color__silver"></i>
                      <span
                        v-if="
                          item.vbIncomingDocQuote || item.vbOutgoingDocQuote
                        "
                      >
                        &nbsp;{{
                          item.vbIncomingDocQuote || item.vbOutgoingDocQuote
                        }}
                      </span>
                    </div>
                  </div>
                  <div class="jobLabelPriority" v-if="item.categoryName">
                    <el-tag
                      size="mini"
                      :class="['priority', getPriorityClass(item.categoryName)]"
                    >
                      <span> {{ item.categoryName }}</span>
                    </el-tag>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="rightSection flex-row flex__right">
            <div class="theTitle__lv2 flex-row flex__left font-size__small">
              <display-people :name="item.assignerName"></display-people>
            </div>
            <div class="theTitle__lv2 flex-row flex__left font-size__small">
              <display-people :name="item.receiverName"></display-people>
            </div>
            <div class="theTitle__lv3 flex-row flex__left font-size__small">
              <div class="flex-row flex__right">
                {{
                item.deadline
                | dateFormatter({
                nullValue: "-",
                dateFormat: "DD/MM/YYYY"
                })
                }}
              </div>
            </div>
            <div class="theTitle__lv3 flex-row flex__left font-size__small">
              <div class="flex-row flex__right">
                <i class="cellIcon color__silver fas fa-clock"></i>
                {{ item.completionTime | dateFormatter({ nullValue: "-" }) }}
              </div>
            </div>
            <div class="theTitle__lv3 flex-row flex__left font-size__small">
              <div class="flex-row flex__right">
                <i class="cellIcon color__silver fas fa-clock"></i>
                {{ item.updateTime | dateFormatter({ nullValue: "-" }) }}
              </div>
            </div>
            <div class="theTitle__lv3 flex-row flex__left font-size__small">
              <div class="flex-row flex__right">
                <div :class="[`jobInfoRate rateLvl-${item.evaluationPoint}`]">
                  <span>{{
                    getEvaluationPointLabel(item.evaluationPoint) || "-"
                  }}</span>
                  {{ item.evaluationPoint }} <i class="fas fa-star"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <infinite-loading
          ref="infiniteLoading"
          spinner="spiral"
          @infinite="infiniteHandler"
          force-use-infinite-wrapper=".el-table__body-wrapper"
        >
          <div slot="no-more"></div>
          <div slot="no-results">Không có dữ liệu</div>
        </infinite-loading>
      </div>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import InfiniteLoading from "vue-infinite-loading";
  import dateFormatter from "../../../filters/dateFormatter";
  import buildShortNameFilter from "../../../filters/buildShortNameFilter";
  import TaskStatusIcon from "./TaskStatusIcon";
  import mainContentCoordinateMixin from "./mainContentCoordinateMixin";
  import DisplayPeople from "../../common/displayPeople";

  export default {
    name: "main-content-coordinator-ketThuc",
    mixins: [mainContentCoordinateMixin],
    props: [
      "keyword",
      "taskStatuses",
      "sort",
      "order",
      "usingAdvanceSearch",
      "advanceSearchForm",
      "viewType",
    ],
    filters: {dateFormatter, buildShortNameFilter},

    components: {
      DisplayPeople,
      TaskStatusIcon,
      InfiniteLoading,
      VuePerfectScrollbar,
      SortCaret: () => import("../../doc-out/SortCaret")
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/job/components/main-content-coordinator-ketThuc.vue